import useNotificationHandler from "hooks/useNotificationHandler";
import { MUTATION_KEYS, QUERY_KEYS } from "library/shared";
import { Attachment } from "library/types";
import { useMutation, useQueryClient } from "react-query";
import api from "service/api";

type Params = {
  countryCode: number | string;
  benefitCategoryTag: number | string;
  clientInternalNumberGOS: number | string;
  benefitImplementationTag: number | string;
  benefitPackageTag: number | string;
  payload: Attachment;
};
const createAttachment = async ({
  countryCode,
  clientInternalNumberGOS,
  benefitCategoryTag,
  benefitImplementationTag,
  benefitPackageTag,
  payload,
}: Params) => {
  const response = await api.post(
    `/benefitpackage/attachment/${countryCode}/${clientInternalNumberGOS}/${benefitCategoryTag}/${benefitImplementationTag}/${benefitPackageTag}`,
    payload
  );

  return response.data as Attachment;
};
export function useCreatePackageAttachment(refetch = true) {
  const queryClient = useQueryClient();
  const { handleAddAxiosErrorNotification } = useNotificationHandler();

  return useMutation(createAttachment, {
    mutationKey: MUTATION_KEYS.createPackageAttachment,
    onSuccess: () => {
      if (refetch) {
        queryClient.refetchQueries({
          queryKey: QUERY_KEYS.benefitImplementationPackages,
        });
      }
    },
    onError: (error) => {
      // handle error
      handleAddAxiosErrorNotification(error);
    },
  });
}
